import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  IntProgressionfaq59u1bhfih as IntProgression,
  CharProgression45cqq4g7w3uj as CharProgression,
} from './Progressions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from './Range.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
  Char__compareTo_impl_ypi4mb28h1l6umahrlb as Char__compareTo_impl_ypi4mb,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
  toString22rbkbhdb5cl2 as toString,
} from '../Char.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.o3_1 = new (IntRange())(1, 0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var IntRangeClass;
function IntRange() {
  if (IntRangeClass === VOID) {
    class $ extends IntProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance();
        super(start, endInclusive, 1);
      }
      z2() {
        return this.q3_1;
      }
      a3() {
        return this.r3_1;
      }
      xo(value) {
        return this.q3_1 <= value && value <= this.r3_1;
      }
      t3(value) {
        return this.xo(typeof value === 'number' ? value : THROW_CCE());
      }
      n1() {
        return this.q3_1 > this.r3_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof IntRange()) {
          tmp = this.n1() && other.n1() || (this.q3_1 === other.q3_1 && this.r3_1 === other.r3_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.n1() ? -1 : imul(31, this.q3_1) + this.r3_1 | 0;
      }
      toString() {
        return '' + this.q3_1 + '..' + this.r3_1;
      }
    }
    initMetadataForClass($, 'IntRange', VOID, VOID, [ClosedRange()]);
    IntRangeClass = $;
  }
  return IntRangeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.yo_1 = new (CharRange())(_Char___init__impl__6a9atx(1), _Char___init__impl__6a9atx(0));
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var CharRangeClass;
function CharRange() {
  if (CharRangeClass === VOID) {
    class $ extends CharProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance_0();
        super(start, endInclusive, 1);
      }
      cp() {
        return this.dp_1;
      }
      z2() {
        return new (Char())(this.cp());
      }
      gp() {
        return this.ep_1;
      }
      a3() {
        return new (Char())(this.gp());
      }
      hp(value) {
        return Char__compareTo_impl_ypi4mb(this.dp_1, value) <= 0 && Char__compareTo_impl_ypi4mb(value, this.ep_1) <= 0;
      }
      t3(value) {
        return this.hp(value instanceof Char() ? value.e4_1 : THROW_CCE());
      }
      n1() {
        return Char__compareTo_impl_ypi4mb(this.dp_1, this.ep_1) > 0;
      }
      equals(other) {
        var tmp;
        if (other instanceof CharRange()) {
          tmp = this.n1() && other.n1() || (this.dp_1 === other.dp_1 && this.ep_1 === other.ep_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp;
        if (this.n1()) {
          tmp = -1;
        } else {
          // Inline function 'kotlin.code' call
          var this_0 = this.dp_1;
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          var tmp_0 = imul(31, tmp$ret$0);
          // Inline function 'kotlin.code' call
          var this_1 = this.ep_1;
          tmp = tmp_0 + Char__toInt_impl_vasixd(this_1) | 0;
        }
        return tmp;
      }
      toString() {
        return toString(this.dp_1) + '..' + toString(this.ep_1);
      }
    }
    initMetadataForClass($, 'CharRange', VOID, VOID, [ClosedRange()]);
    CharRangeClass = $;
  }
  return CharRangeClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstancecdnyz9xt7b9r,
  CharRange as CharRange1dt3801jgpja5,
  IntRange as IntRange1cx8zvxgibbj2,
};
//endregion

//# sourceMappingURL=PrimitiveRanges.mjs.map
